import api from './index'

export default function getStatesByCountry(country) {
  return api.get(`/api/${country}/states`)
}

export function getFormatsByCountry(country) {
  return api.get(`/api/${country}/formats`)
}
